import { hot } from 'react-hot-loader';
import React, { lazy, Suspense } from 'react';
import './App.css';
import { Route, Switch, Redirect } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import MainState from './context/main/MainState';
import ScrollToTop from './components/ScrollToTop';
import ReportState from './context/report/ReportState';
import BuilderStateNew from './context/builderCustom/BuilderStateNew';
import ThemeState from './context/theme/ThemeState';
import AuthState from './context/auth/AuthState';
import CrossMediaState from './context/crossMedia/crossMediaState';
import CrmState from './context/crm/CrmState';
import MMMState from './context/MMM/MMMState';
import LIState from './context/locationIntelligence/LIState';
import ErrorCatcher from './components/Utilities/ErrorCatcher/ErrorCatcher';
import LoadingCircle from './components/Utilities/LoadingCircle';
import PrivateRoute from './components/Utilities/PrivateRoute';
import FolderTreeProvider from './context/folder/FoldersContext/FoldersContextState.jsx';
import MMMListViewProvider from './components/MLModel/MMMListView/context/MMMListViewContext/MMMListViewContextState.jsx';
import {
  AUTH_ROUTES,
  DASHBOARD_ROUTES,
} from './components/Utilities/routePaths';
import NotFound from './components/NotFound';
import AccountHeader from './components/Auth/Components/AccountHeader';
import AudienceState from './context/audience/AudienceState';

const Dashboard = lazy(() => import('./components/Dashboard'));
const AuthRoutes = lazy(() => import('./components/Auth/AuthRoutes'));

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthState>
        <MainState>
          <ErrorCatcher>
            <LIState>
              <CrossMediaState>
                <BuilderStateNew>
                  <ReportState>
                    <AudienceState>
                      <CrmState>
                        <MMMState>
                          <ThemeState>
                            <div className='App'>
                              <ScrollToTop />
                              <Switch>
                                <Redirect
                                  exact
                                  from='/'
                                  to={AUTH_ROUTES.LOGIN}
                                />
                                <PrivateRoute path={DASHBOARD_ROUTES.HOME}>
                                  <FolderTreeProvider>
                                    <MMMListViewProvider>
                                      <Dashboard />
                                    </MMMListViewProvider>
                                  </FolderTreeProvider>
                                </PrivateRoute>
                                <Route
                                  path={AUTH_ROUTES.HOME}
                                  render={(props) => (
                                    <Suspense
                                      fallback={
                                        <LoadingCircle
                                          openState={true}
                                          text='Application is loading...'
                                        />
                                      }
                                    >
                                      <AuthRoutes {...props} />
                                    </Suspense>
                                  )}
                                />
                                <Route
                                  render={() => (
                                    <>
                                      <AccountHeader />
                                      <NotFound />
                                    </>
                                  )}
                                />
                              </Switch>
                            </div>
                          </ThemeState>
                        </MMMState>
                      </CrmState>
                    </AudienceState>
                  </ReportState>
                </BuilderStateNew>
              </CrossMediaState>
            </LIState>
          </ErrorCatcher>
        </MainState>
      </AuthState>
    </ThemeProvider>
  );
}

export default process.env.NODE_ENV === 'development' ? hot(module)(App) : App;
